import React, { useEffect, useState } from 'react';
import * as Styled from './referral-product-footer.styles';

export const ReferralProductFooter = () => {
    const [date, setDate] = useState<number>(0);

    useEffect(() => {
        setDate(new Date().getFullYear());
    }, []);

    return (
        <Styled.ReferralProductFooterContainer>
            <Styled.ReferralProductFooter>
                <Styled.ReferralProductFooterText>
                    © {date} ПАО «МТС». Все&nbsp;права&nbsp;защищены.
                </Styled.ReferralProductFooterText>
                <Styled.ReferralProductFooterAge>&nbsp;18+</Styled.ReferralProductFooterAge>
            </Styled.ReferralProductFooter>
        </Styled.ReferralProductFooterContainer>
    );
};
